<template>
<div>
    <div
        v-if="title"
        class="text-center font-weight-bold text-h6 mb-2"
    >
        {{title}}
    </div>

   <v-row
        align="center"
        justify="center"
    >
        <v-col>
            <Doughnut
                :chartOptions="chart_options"
                :chartData="chart_data"
                style="height: 350px"
            />
        </v-col>
        <v-col>
            <v-data-table
                :headers="table_headers"
                :items="table_rows"
                :items-per-page="100"
                :hide-default-footer="true"
                :footer-props="{
                    disableItemsPerPage: false,
                    disablePagination: false,
                }"
            >
            
                <template v-slot:item.percent="{ item }">
                    {{item.percent}}%
                </template>

                <template v-slot:item.value="{ item }">
                    {{  (currency ? '$' : '')+parseInt(item.value).toLocaleString()}}
                </template>

                <template slot="body.append">
                    <tr>
                        <td style="font-weight: bold">Total</td>
                        <td style="font-weight: bold">{{(currency ? '$' : '')+total.toLocaleString()}}</td>
                        <td style="font-weight: bold">100.0%</td> 
                    </tr>
                </template>
            
            </v-data-table>
        </v-col>

    </v-row>
    

</div>
</template>

<script>
const _ = require('lodash');
import { Doughnut } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ArcElement } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ArcElement)

export default {
    components: { Doughnut },

    props: {
        title: {
            type: String,
            default: function() { return "Set title to properly title the chart!"}
        },

        currency: {
            type: Boolean,
            default: function() { return false; }
        },

        show_legend: {
            type: Boolean,
            default: function() { return true; }
        },

        labels: {
            type: Array,
            default: function() { return []; }
        },

        data: {
            type: Array,
            default: function() { return []; }
        },

        table_headers: {
            type: Array,
            default: function() { return []; }
        },

        table_rows: {
            type: Array,
            default: function() { return []; }
        },

        colors: {
            type: Array,
            default: function() { 
                return ["rgba(241,70,82,0.5)", "rgba(70,241,82,0.5)", "rgba(70,82,241,0.5)", "rgba(241,241,82,0.5)", "rgba(70,241,241,0.5)", "rgba(241,82,241,0.5)", "rgba(225,225,225,0.5)"]; 
            }
        },
    },

    data() {
        return {
        }
    },

    methods: {
    },

    computed: {
        chart_options() {
            let ret = {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: this.show_legend,
                        },
                        tooltip: {
                            callbacks: {
                                label: (context) => {
                                    const label = context.label || '';
                                    const value = (this.currency ? '$' : '') + context.formattedValue;
                                    return ` ${label}: ${value}`;
                                }
                            },
                        },
                    }
                };


            return ret;
        },

        chart_data() {
            return {
                'labels': this.labels,
                'datasets': [{
                    'label': this.title,
                    'backgroundColor': this.colors,
                    'data': this.data,
                }],
            };
        },

        total()
        {
            if ( this.table_rows == null ) 
                return 0;

            return this.table_rows
                    .map((el) => parseInt(el.value))
                    .filter((el) => !isNaN(el))
                    .reduce((a,b) => a + b, 0);
        }
    },
}
</script>

<style lang="scss" scoped>

</style>